import React from 'react'
import { makeStyles } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from 'app/session/store'
import { Spinner } from 'components'
import { getConfig, geti18n } from 'app/api'
import { updateConfig, updatei18n } from 'app/session/actions'
import TechnicalIssue from 'views/screens/errors/TechnicalIssue'
import { initializeAnalytics } from 'app/utils'
import { useLocalization } from 'components/methods'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
}))

type ConfiguratorProps = {
  children?: React.ReactNode
}

const Configurator = (props: ConfiguratorProps) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const session = useSelector((state: RootState) => state.session)
  const { setLanguage } = useLocalization()
  const locale = 'it_IT'

  const [isInitialized, setIsInitialized] = React.useState(false)
  const [configurationAvailable, setConfigurationAvailable] = React.useState<boolean | null>(null)
  const [i18nAvailable, seti18nAvailable] = React.useState<boolean | null>(null)
  const [requirementsAvailable, setRequirementsAvailable] = React.useState<boolean | null>(null)

  React.useEffect(() => {
    downloadConfiguration()
  }, [])

  function downloadConfiguration() {
    if (session.config != null) return

    getConfig({
      response(response) {
        dispatch(updateConfig(response))
      },
      error(error) {
        setRequirementsAvailable(false)
      }
    })
  }

  function downloadi18n() {
    if (session.i18n != null) return

    if (session.config?.app.i18nUrl == null) {
      seti18nAvailable(false)
      return
    }
    
    const params = {
      locale: locale
    }
    geti18n(params, session.config, {
      response(response) {
        dispatch(updatei18n(response))
        seti18nAvailable(true)
      },
      error(error) {
        seti18nAvailable(false)
      }
    })
  }

  React.useEffect(() => {
    setLanguage(locale)
  }, [])
  
  React.useEffect(() => {
    if (session.config == null) return
    setConfigurationAvailable(true)
  }, [session.config])

  React.useEffect(() => {
    if (configurationAvailable !== true) return
    
    if (session.config?.type !== 'development') {
      console.error = () => {}      
    }

    downloadi18n()
    initializeAnalytics(session.config)
  }, [configurationAvailable])

  React.useEffect(() => {
    const init = configurationAvailable != null && i18nAvailable != null
    setIsInitialized(init)

    if (configurationAvailable == null || i18nAvailable == null) return
    const req = configurationAvailable === true
    setRequirementsAvailable(req)
  }, [configurationAvailable, i18nAvailable])

  React.useEffect(() => {
    if (requirementsAvailable === false) setIsInitialized(true)
  }, [requirementsAvailable])

  if (isInitialized === false) return (
    <div className={classes.root}>
      <Spinner />
    </div>
  )

  if (requirementsAvailable === false) return (
    <TechnicalIssue />
  )

  return (
    <>
      {props.children}
    </>
  )
}

export default Configurator
